import { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "../i18n/translations";

const LanguageContext = createContext(null);

export const useLang = () => useContext(LanguageContext);

const getNested = (obj, path) => path.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);

const SUPPORTED = LANGUAGES.map((l) => l.code);

const detectLang = () => {
  const stored = localStorage.getItem("adj_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;
  const navLangs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]) || [];
  for (const l of navLangs) {
    const code = (l || "").slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(code)) return code;
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);

  const setLang = useCallback((code) => {
    localStorage.setItem("adj_lang", code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key, vars) => {
      let val = getNested(translations[lang], key);
      if (val === undefined) val = getNested(translations.it, key);
      if (typeof val === "string" && vars) {
        Object.entries(vars).forEach(([k, v]) => {
          val = val.replace(`{${k}}`, v);
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
